var React = require('react');

function ArrowBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.1248 19.1L0.699805 10.7C0.599805 10.6 0.529138 10.4917 0.487805 10.375C0.445805 10.2583 0.424805 10.1333 0.424805 9.99999C0.424805 9.86666 0.445805 9.74166 0.487805 9.62499C0.529138 9.50833 0.599805 9.39999 0.699805 9.29999L9.1248 0.874994C9.35814 0.64166 9.6498 0.524994 9.9998 0.524994C10.3498 0.524994 10.6498 0.649994 10.8998 0.899994C11.1498 1.14999 11.2748 1.44166 11.2748 1.77499C11.2748 2.10833 11.1498 2.39999 10.8998 2.64999L3.5498 9.99999L10.8998 17.35C11.1331 17.5833 11.2498 17.8707 11.2498 18.212C11.2498 18.554 11.1248 18.85 10.8748 19.1C10.6248 19.35 10.3331 19.475 9.9998 19.475C9.66647 19.475 9.3748 19.35 9.1248 19.1Z","fill":"white"}));
}

ArrowBack.defaultProps = {"width":"12","height":"20","viewBox":"0 0 12 20","fill":"none"};

module.exports = ArrowBack;

ArrowBack.default = ArrowBack;
